import { createTheme } from '../theme';

function defaultLabelDisplayedRows(props: { from: number; to: number; count: number }) {
  const { from, to, count } = props;
  return `${from}–${to} จาก ${count !== -1 ? count : `more than ${to}`}`;
}

const theme = createTheme({
  components: {
    MuiTablePagination: {
      defaultProps: {
        rowsPerPageOptions: [10, 20, 50, 100],
        labelRowsPerPage: 'แสดงแถว',
        labelDisplayedRows: defaultLabelDisplayedRows,
        showFirstButton: true,
        showLastButton: true,
      },
      styleOverrides: {
        root: ({ theme }) => ({
          color: theme.palette.grey['700'],
        }),
        input: ({ theme: { unstable_sx: sx } }) =>
          sx({
            mr: 1,
            minWidth: '65px',
            alignItems: 'center',
          }),
        select: ({ theme: { unstable_sx: sx } }) =>
          sx({
            borderColor: theme.palette.grey['400'],
            borderWidth: '1px',
            borderStyle: 'solid',
            borderRadius: '4px',
            fontWeight: 600,
            fontSize: 14,
            textAlignLast: 'center',
            ':focus': {
              backgroundColor: 'transparent',
              borderRadius: '4px',
            },
          }),
        selectRoot: ({ theme: { unstable_sx: sx } }) => sx({ mr: 1 }),
      },
    },
  },
});

export default theme.components;
